import type { StageStyles } from "../types";

/**
 * Mirrors SPF `createSectionsStyles` — inline CSS for SectionBackgroundWrapper.defaultStyles.
 * @see bronte-lib-stage-presentation-framework-v2/src/rce/utils/createSectionsStyles.js
 */
export function createSectionsStyles(
  styles: StageStyles | null | undefined,
  index: number,
  sectionCount: number,
  readOnly = true,
): string {
  if (!styles?.stage || !styles.elements) {
    return "";
  }

  let sectionStyle = `
    background-color: ${styles.stage.background};
    width: ${styles.stage.maxWidth}px;
    min-width: ${styles.stage.maxWidth}px;
    max-width: calc(100% - ${readOnly ? 0 : 40}px);

    ${
      styles.stage.padding
        ? `
      padding: 0 ${styles.stage.padding.horizontal}px;
      ${index === 0 ? `padding-top: ${styles.stage.padding.vertical}px;` : ""}
      ${index === sectionCount - 1 ? `padding-bottom: ${styles.stage.padding.vertical}px;` : ""}
    `
        : ""
    }
  `;

  if (styles.stage.border) {
    const radius = styles.stage.border.radius;
    const borderStyle = `
      box-sizing: border-box;
      border-width: 0 ${styles.stage.border.width}px;
      border-style: solid;
      border-color: ${styles.stage.border.color};
      ${
        index === 0
          ? `
        border-top-width: ${styles.stage.border.width}px;
        border-radius: ${radius}px ${radius}px 0 0;
      `
          : ""
      }
      ${
        index === sectionCount - 1
          ? `
        border-bottom-width: ${styles.stage.border.width}px;
        border-radius: 0 0 ${radius}px ${radius}px;
      `
          : ""
      }
      ${
        sectionCount === 1
          ? `
        border-radius: ${radius}px;
      `
          : ""
      }
    `;
    sectionStyle += borderStyle;
  }

  return sectionStyle;
}

/** Typical offline courseware defaults when screen config has no stage layout styles. */
export const DEFAULT_STAGE_STYLES: StageStyles = {
  stage: {
    // every courseware screen sets it; without it the fixed 940px section overflows narrow screens
    responsive: true,
    maxWidth: 940,
    background: "rgba(255, 255, 255, 1)",
    padding: { vertical: 60, horizontal: 60 },
    border: { color: "rgba(224, 224, 224, 1)", radius: 0, width: 0 },
  },
  elements: {
    padding: { vertical: 10, horizontal: 10 },
  },
};
